import { render, staticRenderFns } from "./ProjectMultiselectOption.vue?vue&type=template&id=117de3ba"
import script from "./ProjectMultiselectOption.vue?vue&type=script&lang=ts"
export * from "./ProjectMultiselectOption.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/codebuild/output/src4020427597/src/jobbliss-app-vue/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('117de3ba')) {
      api.createRecord('117de3ba', component.options)
    } else {
      api.reload('117de3ba', component.options)
    }
    module.hot.accept("./ProjectMultiselectOption.vue?vue&type=template&id=117de3ba", function () {
      api.rerender('117de3ba', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/autocompleteMultiselects/ProjectMultiselectOption.vue"
export default component.exports